<template>
  <div class="mp-auth">
    <template v-if="!isLoading">
      <auth
        v-if="isAuth"
        @validateDialog="getValidateDialog"
      />
      <un-auth
        v-else
        @validateDialog="getValidateDialog"
      />
    </template>
    <!-- 验证授权弹窗 -->
    <mk-dialog
      width="456px"
      :visible.sync="validateDialog"
    >
      <div class="dialog-title">
        <span>
          <ds-iconfont icon-class="icon-mk-tishi-info" />
          授权提示
        </span>
        <span class="close">
          <i
            class="el-icon-close"
            @click="validateDialog = false"
          ></i>
        </span>
      </div>
      <div class="dialog-text">
        是否授权成功？
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <mk-button
          size="medium"
          class="cancel-button"
          @click="reloadPage"
        >授权失败</mk-button>
        <mk-button
          size="medium"
          type="primary"
          @click="reloadPage"
        >授权成功</mk-button>
      </span>
    </mk-dialog>
    <!-- 重新授权弹窗 -->
    <mk-dialog
      width="456px"
      :visible.sync="reAuthDialog"
    >
      <div class="dialog-title">
        <span>
          <ds-iconfont icon-class="icon-mk-tishi-info" />
          请您注意
        </span>
        <span class="close">
          <i
            class="el-icon-close"
            @click="reAuthDialog = false"
          ></i>
        </span>
      </div>
      <div class="dialog-text">
        {{ msg }}
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <mk-button
          size="medium"
          class="cancel-button"
          @click="cancelReAuth"
        >取消</mk-button>
        <mk-button
          size="medium"
          type="primary"
          @click="reAuth"
        >重新授权</mk-button>
      </span>
    </mk-dialog>
    <!-- 重新授权弹窗 -->
    <mk-dialog
      width="456px"
      :visible.sync="confirmAuthSuccess"
    >
      <div class="dialog-title">
        <span>
          <ds-iconfont icon-class="icon-mk-success" />
          请您注意
        </span>
        <span class="close">
          <i
            class="el-icon-close"
            @click="confirmAuthSuccess = false"
          ></i>
        </span>
      </div>
      <div class="dialog-text">
        您已成功授权！
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <mk-button
          size="medium"
          type="primary"
          @click="confirmAuthSuccess=false"
        >确认</mk-button>
      </span>
    </mk-dialog>
  </div>
</template>

<script>
import unAuth from './components/unAuth'
import auth from './components/auth'
export default {
  name: 'MpAuth',
  components: {
    auth, unAuth
  },
  data () {
    return {
      // 是否授权小程序
      isAuth: false,
      // 授权成功弹窗
      validateDialog: false,
      // 重新授权弹窗状态
      reAuthDialog: false,
      // 授权成功提示弹窗
      confirmAuthSuccess: false,
      // 回调返回msg
      msg: '',
      // 是否正在加载
      isLoading: true
    }
  },
  async created () {
    this.getRouterQuery()
    this.jugeAuthorized()
  },
  methods: {
    toAuth () {
      const { VUE_APP_WX_OPEN_BASE_URL } = process.env
      const dustessUrl = encodeURIComponent(
        window.location.origin + '/#/settings/auth-management?type=2'
      )
      const { account } = JSON.parse(window.localStorage.getItem('user'))
      const url = `${VUE_APP_WX_OPEN_BASE_URL}/wxopen/v1/mini/auth/page?companyId=${account}&dustessUrl=${dustessUrl}`
      window.open(url)
      this.validateDialog = true
    },
    // 用户点击验证弹窗‘授权失败/授权成功’重新加载页面’
    reloadPage () {
      location.reload()
    },
    // 初始化获取路由信息根据code判断授权是否成功
    getRouterQuery () {
      let query = this.$route.query
      if (query.code === '0') {
        this.reAuthDialog = false
        this.confirmAuthSuccess = true
        this.authorizerAppId = query.authorizerAppId
      } else if (query.code && query.code !== '0') {
        this.msg = query.msg
        this.reAuthDialog = true
        this.isAuth = false
      }
    },
    // 判断用户是否授权
    async jugeAuthorized () {
      this.isLoading = true
      const user = JSON.parse(window.localStorage.getItem('user'))
      let { success, data } = await BIZAPIS.ManageMiniApi.authManageWeixinMiniIsAuthGet()
      if (success) {
        // 已授权
        if (data.status === 0) {
          this.isAuth = true
        } else {
          this.isAuth = false
        }
      } else {
        // 未授权
        this.isAuth = false
      }
      this.isLoading = false
    },
    // 回调页，授权失败，重新授权
    reAuth () {
      this.reAuthDialog = false
      this.validateDialog = true
      this.toAuth()
    },
    // 回调页，授权失败，取消授权
    cancelReAuth () {
      this.reAuthDialog = false
    },
    // 用户操作‘授权失败’或‘授权成功’弹窗状态
    getValidateDialog (val) {
      this.validateDialog = val
    }
  }
}
</script>

<style lang="scss" scoped>
.mp-auth {
  /deep/ .el-dialog__header {
    display: none;
  }

  .dialog-title {
    height: 24px;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #262626;

    .icon-mk-tishi-info {
      font-size: 19px;
      color: #fa8c15;
      margin-right: 11px;
    }

    .icon-mk-success {
      font-size: 19px;
      color: #15ad31;
      margin-right: 11px;
    }

    .el-icon-close {
      color: #bfbfbf;
      cursor: pointer;
    }
  }

  .dialog-text {
    padding-left: 35px;
    margin-top: 12px;
    color: #595959;
    line-height: 20px;
  }

  .cancel-button {
    color: #009cff;
    border-color: #ccecff;
  }

  /deep/ .el-dialog__body {
    padding: 20px 22px 28px;
  }

  /deep/ .el-dialog__footer {
    padding-top: 0 !important;
  }
}
</style>
